import React from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import {
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';

import ErrorBoundary from '../../ErrorBoundary';

const AdminGroupEditMainEdit = ({
  group,
  groupId,
  errors,
  handleChange,
  ...props
}) => {
  const intl = useIntl();

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <p>
          {intl.formatMessage({ defaultMessage: 'Edit the Team name and description.' })}
        </p>
        <div className="profile-form">
          <div className="profile-avatar-wrapper">
            <div className="profile-avatar">
              <div className="avatar avatar-200 icon-avatar gray">
                <i className="far fa-users-class" />
              </div>
            </div>
          </div>
          <div className="profile-details">
            <FormGroup>
              <Label for="inpGroupName">
                {intl.formatMessage({ defaultMessage: 'Name' })}
              </Label>
              <Input
                type="text"
                name="name"
                id="inpGroupName"
                placeholder={intl.formatMessage({ defaultMessage: 'Team name' })}
                defaultValue={group.name}
                onChange={handleChange}
                invalid={errors.includes('name')}
              />
              {errors.includes('name') && (
                <FormFeedback>
                  {intl.formatMessage({ defaultMessage: 'This field is required' })}
                </FormFeedback>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="inpGroupDescription">
                {intl.formatMessage({ defaultMessage: 'Description' })}
              </Label>
              <Textarea
                name="description"
                id="inpGroupDescription"
                className="form-control"
                placeholder={intl.formatMessage({ defaultMessage: 'Team description (optional)' })}
                defaultValue={group.description}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup check>
              <Label for="inpDefaultInUpload">
                <Input
                  type="checkbox"
                  id="inpDefaultInUpload"
                  name="default_in_upload"
                  className="input-check check-s form-check-input no-margin"
                  defaultChecked={group.default_in_upload}
                  onChange={handleChange}
                />
                {' '}
                {intl.formatMessage({
                  defaultMessage: 'Default this Team as collaborators while uploading files',
                })}
              </Label>
            </FormGroup>
          </div>
        </div>
      </div>
      <AdminEditButtons
        {...props}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Team' })}
        hideDelete={groupId === null}
      />
    </ErrorBoundary>
  );
};

AdminGroupEditMainEdit.propTypes = {
  group: PropTypes.object,
  groupId: PropTypes.string,
  errors: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
};

AdminGroupEditMainEdit.defaultProps = {
  group: null,
  groupId: null,
};

export default AdminGroupEditMainEdit;
